import React, { FC, useState, useEffect } from 'react'
import i18n from 'i18next'
import { IonContent, IonFooter, IonSpinner, IonToast } from '@ionic/react'
import payMobx, { ICard } from '@mobx/pay/pay.mobx'
import { observer } from 'mobx-react'

const css = encodeURIComponent('.error{color:red;border-color:red}input{-webkit-appearance: none;border: 1px solid #E6E6E6;color: #333;font-size: 16px;border:1px solid rgba(230,230,230,1);border-radius:4px;width: 100%;padding: 10px;margin-top: 0px;box-sizing: border-box;}input:active {background:rgba(245,245,245,1);border:1px solid rgba(191,191,191,1);}select{-webkit-appearance: none;background:#fff;font-size:16px;width: 30%;margin: 0px 15px 10px 0;padding:10px;border:1px solid rgba(230,230,230,1);}')

interface IProps {
  onAuthorize(card: ICard): void;
}

const CardConnectTokenizer: FC<IProps> = ({ onAuthorize }) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  const [token, setToken] = useState<string>()
  const [expiry, setExpiry] = useState<string>()
  const [errorMessage, setErrorMessage] = useState<string>()
  const [authorizing, setAuthorizing] = useState<boolean>(false)

  const auth = async () => {
    setAuthorizing(true)
    try {
      const newCard = await payMobx.authBankCard('CardConnectBankCard', token)
      onAuthorize(newCard)
    } catch (e) {
      console.error('error auth card', e)
      setErrorMessage(e.message)
    } finally {
      setAuthorizing(false)
    }
  }

  const tokenFromEvent = (event: MessageEvent) => {
    if (event.data) {
      try {
        const msg = JSON.parse(event.data)
        setToken(msg.message)
        setExpiry(msg.expiry)
      } catch (e) {
        // ignore
      }
    }
  }

  const onTokenizerLoaded = () => {
    setTimeout(() => {
      setLoaded(true)
    }, 300)
  }

  useEffect(() => {
    window.addEventListener('message', tokenFromEvent)
    return () => {
      window.removeEventListener('message', tokenFromEvent)
    }
  }, [])

  const { server, port } = payMobx.channelAccountMap.CardConnectBankCard
  const url = `https://${server}.cardconnect.com:${port}/itoke/ajax-tokenizer.html?css=${css}&tokenizewheninactive=true&useexpiry=true&usecvv=true`

  return (
    <>
      <IonToast
        position='top'
        color='danger'
        isOpen={!!errorMessage}
        onDidDismiss={() => setErrorMessage('')}
        message={errorMessage}
        duration={2000}
      />
      <IonContent className='card-connect-tokenizer'>
        {!loaded && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.jumpToProcessorPage')}</div>
          </div>
        )}
        {authorizing && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.authorizingCard')}</div>
          </div>
        )}
        <iframe
          id='cardConnectTokenizer'
          name='cardConnectTokenizer'
          src={url}
          frameBorder='0'
          scrolling='no'
          onLoad={onTokenizerLoaded}
        />
      </IonContent>
      <IonFooter>
        {loaded && (
          <>
            <div className='processor-power-by'>{i18n.t('pay.powerByProcessor')}</div>
            <button className='submit-button' disabled={!token || authorizing} onClick={auth}>
              {i18n.t('pay.confirmAddBankCard')}
            </button>
          </>
        )}
      </IonFooter>
    </>
  )
}

export default observer(CardConnectTokenizer)
